import { Controller } from "stimulus"

export default class extends Controller {
  static values = { width: String }

  connect() {
    if (this.hasWidthValue) {
      this.element.style.width = this.widthValue
    }
  }
}
